export default {
    data: [],
    loading: false,
    success: false,
    error: false,
};
